
export default function initMap () {
  let map;
  map = new google.maps.Map(document.getElementById('map'), {
    center: {lat: 50.316147, lng: 4.030625},
    zoom: 8,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    center: new google.maps.LatLng(50.316147, 4.030625),
    scaleControl: false,
    scrollwheel: false
  });

  let iconBase = '../images/pin.png',
  marker = new google.maps.Marker({
    position: new google.maps.LatLng(50.316147, 4.030625),
    map: map,
    icon: iconBase
  });

  marker.setMap(map);
}
